module.exports = __webpack_public_path__ + "src/img/bottomIcon.afacb8dc.png";